import { render, staticRenderFns } from "./BBBLiveMeetings.vue?vue&type=template&id=1a563302"
import script from "./BBBLiveMeetings.vue?vue&type=script&lang=js"
export * from "./BBBLiveMeetings.vue?vue&type=script&lang=js"
import style0 from "./BBBLiveMeetings.vue?vue&type=style&index=0&id=1a563302&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports